import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class MaintenancePage extends PureComponent {
  static propTypes = {
    isLoggingOut: PropTypes.bool.isRequired,
  };

  render() {
    if (this.props.isLoggingOut) {
      return null;
    }

    return (
      <div className="maintenance-page page-without-secondary-menu page-content-container">
        <h2>Maintenance</h2>
        <div className="maintenance-page__text">
          <div>Tax Lifecycle Solutions (TLS) is currently undergoing routine maintenance.</div>
          <div>We are sorry for any inconvenience.</div>
          <div>Please try again later.</div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  isLoggingOut: state.user.isLoggingOut,
}), {
})(MaintenancePage);
